// Data dnia w nagłówku strony głównej (U.30). Czyste: język i dzień przychodzą z zewnątrz.
import { formatLongDate, localeTag } from './format';

/** „Sobota, 10 października 2026”: pełna data w języku panelu, z wielką literą na początku. */
export function formatHeaderDate(date, language) {
  const text = formatLongDate(date, { locale: language, fallback: '' });
  return text.charAt(0).toLocaleUpperCase(localeTag(language)) + text.slice(1);
}
